var React = require('react');

function WaveBottom (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M-112.751 42.8166C-12 58.3166 17 52.8166 87 27.3166C157 1.81662 218.294 60.4874 311.48 74.4874C404.667 88.4874 417.023 14.9874 509.18 1.4874C601.337 -12.0126 567.5 71.507 704.5 45.8167C832.459 21.8216 684.39 308.001 664.29 345.875C662.916 348.464 660.264 349.987 657.333 349.987H-21.1416C-23.99 349.987 -26.5871 348.534 -28.0013 346.061C-48.9823 309.379 -206.938 28.3264 -112.751 42.8166Z"}));
}

WaveBottom.defaultProps = {"width":"659","height":"77","viewBox":"0 0 659 77","fill":"none"};

module.exports = WaveBottom;

WaveBottom.default = WaveBottom;
